export default {
  priv: 'pr_templates',
  overviewTitle: 'Document Templates',
  detailTitle: 'Document Template',
  deleteTitle: 'deze document template',
  url: '/templates/docs',
  apiUrl: '/doctemplates/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'templates/docs',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  tableFields: [
    {text: 'Naam', value: 'name', link: '/templates/docs/{id}', width: '30%'},
    {text: 'Bestandsnaam', value: 'file.name', width: '30%'},
    {text: 'Bestand', value: 'file', width: '10%', type: 'file', align: 'center', sortable: false},
    {text: 'Laatste aanpassing', value: 'file.timestamp', width: '15%', align: 'center', filter: 'timestamp'}
  ]
};
